import { CustomTabs } from 'app/components'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { EmpresaValoresListSearchComponent } from './EmpresaValoresListSearchComponent'
import { EmpresaValoresListToolbar } from './EmpresaValoresListToolbar'

type Aba = 'atuais' | 'historico'

const ABAS: { id: Aba; label: string }[] = [
  { id: 'atuais', label: 'Valores atuais' },
  { id: 'historico', label: 'Histórico' },
]

/** Abas (valores atuais/histórico) no topo do card e, abaixo, a barra de filtros. */
export const EmpresaValoresListHeader = () => {
  const { state, updateState } = useQueryRequest()
  const aba = (state.tab as Aba) ?? 'atuais'

  return (
    <div className='card-header border-0 pt-6 d-flex flex-column gap-4'>
      <CustomTabs<Aba>
        tabs={ABAS}
        activeTab={aba}
        onChange={(tab) => updateState({ tab, page: 0, sort: undefined, order: undefined })}
      />

      <EmpresaValoresListSearchComponent
        actions={aba === 'atuais' ? <EmpresaValoresListToolbar /> : undefined}
      />
    </div>
  )
}
